<ate-ui-header [logoOnly]="true"></ate-ui-header>

<div class="container">
  <router-outlet></router-outlet>
</div>
